import Reveal from "@/components/Reveal";

export default function Manifesto({ chapters, t }) {
  return (
    <section id="etica" data-testid="manifesto-section" className="py-20 sm:py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal>
          <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C86D51] mb-4">
            {t.manifesto.over}
          </p>
          <h2 className="font-display tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#241C1A] max-w-2xl leading-[1.1]">
            {t.manifesto.title}
          </h2>
        </Reveal>

        <div className="mt-16 sm:mt-24 space-y-20 sm:space-y-28">
          {chapters.map((ch, i) => (
            <div
              key={ch.number}
              data-testid={`manifesto-chapter-${ch.number}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 items-center"
            >
              <Reveal
                delay={0.05}
                className={`md:col-span-6 lg:col-span-5 ${i % 2 === 1 ? "md:order-2 md:col-start-7" : ""}`}
              >
                <div className="relative">
                  <img
                    src={ch.image}
                    alt={ch.alt}
                    loading="lazy"
                    className={`w-full object-cover shadow-xl shadow-[#1E1614]/15 ${
                      i % 2 === 0
                        ? "aspect-[4/5] rounded-t-[8rem] rounded-b-3xl"
                        : "aspect-[4/3] rounded-3xl"
                    }`}
                  />
                  {ch.badge && (
                    <img
                      src={ch.badge}
                      alt="Certificazione AIC — Alimentazione Fuori Casa senza glutine"
                      data-testid="aic-badge"
                      loading="lazy"
                      className="absolute -bottom-6 -right-4 sm:-right-6 w-24 sm:w-28 rounded-full shadow-lg border-4 border-[#FAF7F2]"
                    />
                  )}
                </div>
              </Reveal>
              <div className={`md:col-span-6 lg:col-span-6 ${i % 2 === 1 ? "md:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
                <Reveal delay={0.15}>
                  <span className="font-accent text-5xl sm:text-6xl text-[#C86D51]/30 leading-none block">
                    {ch.number}
                  </span>
                  <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#506334] mt-4">
                    {ch.tag}
                  </p>
                  <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl text-[#241C1A] mt-2 tracking-tight">
                    {ch.title}
                  </h3>
                  <p className="text-base sm:text-lg leading-relaxed text-[#6E625E] mt-5 max-w-lg">
                    {ch.text}
                  </p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
